module.exports = "pegasus_template/assets/themelp1/small/10.png";